import { BoxProps, Flex, Text, Tooltip } from '@chakra-ui/react';
import { useActiveSession } from '@texas/hooks/useSession';
import {
  BranchIdentifier,
  getBranchColor,
} from '@texas/utils/helpers/texas/branchHelpers';

interface Props extends BoxProps {
  name: string;
  userId: number;
  branch?: string;
}

export function UserBadge({ name, userId, branch, ...props }: Props) {
  const split = name.split(' ');
  const session = useActiveSession();

  return (
    <Tooltip label={name}>
      <Flex
        {...props}
        alignItems="center"
        justifyContent="center"
        bg={branch ? getBranchColor(branch as BranchIdentifier) : 'gray.600'}
        boxSize={8}
        borderRadius="full"
        textTransform="uppercase"
        fontSize="sm"
        fontWeight="bold"
        pos="relative"
        _light={{
          bg: branch ? getBranchColor(branch as BranchIdentifier) : 'gray.200',
        }}
        {...(session.currentUser.id === userId
          ? {
              border: '2px solid',
              borderColor: 'texas.sand.100',
              _light: {
                bg: branch
                  ? getBranchColor(branch as BranchIdentifier)
                  : 'gray.200',
                borderColor: 'texas.burntSienna.100',
              },
            }
          : null)}
      >
        <Text color="white">{`${split[0][0]}`}</Text>
      </Flex>
    </Tooltip>
  );
}
